module.exports = __webpack_public_path__ + "img/กุ้ง.a2560469.png";